import { Ticket } from '../../types/ticket';
import { Rule } from '../types/Rule';
import { RuleContext } from '../types/RuleContext';

/**
   * Function to collect tickets with the access key applied to the cart.
   * Filters tickets whose type contains any element with the `hidden` property set to true, which is the key that identifies hidden tickets
 */

export class RemoveTicketsWithPasskeyRule implements Rule {
  apply(context: RuleContext): Ticket[] {
    const { cart, passKeyApplied } = context;
    if (!passKeyApplied && cart && cart.length !== 0) {
      const newCart = cart?.filter(({ type }) =>
        type.every(({ hidden }) => !hidden)
      );

      cart.forEach((ticket) => {
        ticket.type.forEach((type) => {
          const ticketStillExists = newCart.some(t =>
            t.id === ticket.id && t.type.some(tt => tt.id === type.id)
          );

          if (!ticketStillExists) {
            const definitiveSessionId = ticket.type[0].dates.map((date) => date.id).join('');
            if(definitiveSessionId && context.updateTicketsPerSession) {
              context.updateTicketsPerSession(definitiveSessionId, type.quantityInCart || 0);
            }
          }
        });
      });

      return newCart;
    }

    return cart || [];
  }
}
